import { render, staticRenderFns } from "./correctionDetail.vue?vue&type=template&id=1cf794f7&scoped=true"
import script from "./correctionDetail.vue?vue&type=script&lang=js"
export * from "./correctionDetail.vue?vue&type=script&lang=js"
import style0 from "./correctionDetail.vue?vue&type=style&index=0&id=1cf794f7&style=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf794f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf794f7')) {
      api.createRecord('1cf794f7', component.options)
    } else {
      api.reload('1cf794f7', component.options)
    }
    module.hot.accept("./correctionDetail.vue?vue&type=template&id=1cf794f7&scoped=true", function () {
      api.rerender('1cf794f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/correctionRecord/correctionDetail.vue"
export default component.exports